<template>
  <v-container fluid>

    <!-- ประเมิน ภาค ข ส่วนที่ 1 ผู้สมัครคัดเลือก ตำแหน่งผู้อำนวยการวิทยาลัย -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_vecprovince_dirb.period_vecprovince_enable === '1' || period_vecprovince_dirb.period_vecprovince_enable === 1">
      <div class="hrvec-priority-bar normal"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #f59e0b">
                <v-icon size="20" color="white">mdi-account-supervisor</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="secondary" outlined>
                    <v-icon left x-small>mdi-domain</v-icon>
                    สำนักงานอาชีวศึกษาจังหวัด
                  </v-chip>
                  <v-chip x-small color="orange">
                    <v-icon left x-small>mdi-star-box</v-icon>
                    ประเมิน ภาค ข
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">ประเมิน ภาค ข ส่วนที่ 1 ผู้สมัครคัดเลือก</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">ตำแหน่ง ผู้อำนวยการวิทยาลัย</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ (16:30 น.)</div>
              <div class="hrvec-countdown-date">
                {{ period_vecprovince_dirb.period_vecprovince_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
              </div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="period_vecprovince_dirb.period_vecprovince_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ตรวจสอบคุณสมบัติ ผู้สมัครคัดเลือก รองผู้อำนวยการ -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_vecprovince_ap.period_vecprovince_enable === '1' || period_vecprovince_ap.period_vecprovince_enable === 1">
      <div class="hrvec-priority-bar normal"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #0288d1">
                <v-icon size="20" color="white">mdi-account-check</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="secondary" outlined>
                    <v-icon left x-small>mdi-domain</v-icon>
                    สำนักงานอาชีวศึกษาจังหวัด
                  </v-chip>
                  <v-chip x-small color="info">
                    <v-icon left x-small>mdi-clipboard-check</v-icon>
                    ตรวจสอบคุณสมบัติ
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">ตรวจสอบคุณสมบัติ ผู้สมัครคัดเลือก</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">ตำแหน่ง รองผู้อำนวยการ</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ (16:30 น.)</div>
              <div class="hrvec-countdown-date">
                {{ formatDateToThaiIntl(period_vecprovince_ap.period_vecprovince_stop) }}
              </div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="period_vecprovince_ap.period_vecprovince_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ตรวจสอบคุณสมบัติ ผู้สมัครคัดเลือก ผู้อำนวยการ -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_vecprovince_apdir.period_vecprovince_enable === '1' || period_vecprovince_apdir.period_vecprovince_enable === 1">
      <div class="hrvec-priority-bar normal"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #7c3aed">
                <v-icon size="20" color="white">mdi-account-supervisor-circle</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="secondary" outlined>
                    <v-icon left x-small>mdi-domain</v-icon>
                    สำนักงานอาชีวศึกษาจังหวัด
                  </v-chip>
                  <v-chip x-small color="purple">
                    <v-icon left x-small>mdi-account-star</v-icon>
                    ตรวจสอบคุณสมบัติ ผอ.
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">ตรวจสอบคุณสมบัติ ผู้สมัครคัดเลือก</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">ตำแหน่ง ผู้อำนวยการวิทยาลัย</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ (16:30 น.)</div>
              <div class="hrvec-countdown-date">
                {{ formatDateToThaiIntl(period_vecprovince_apdir.period_vecprovince_stop) }}
              </div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="period_vecprovince_apdir.period_vecprovince_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ประเมิน ภาค ข รองผู้อำนวยการ -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_vecprovince_b.period_vecprovince_enable === '1' || period_vecprovince_b.period_vecprovince_enable === 1">
      <div class="hrvec-priority-bar normal"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #16a34a">
                <v-icon size="20" color="white">mdi-clipboard-account</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="secondary" outlined>
                    <v-icon left x-small>mdi-domain</v-icon>
                    สำนักงานอาชีวศึกษาจังหวัด
                  </v-chip>
                  <v-chip x-small color="success">
                    <v-icon left x-small>mdi-star-box</v-icon>
                    ประเมิน ภาค ข
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">ประเมิน ภาค ข ตำแหน่งรองผู้อำนวยการ</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">ครั้งที่ {{ period_vecprovince_b.period_vecprovince_times }}/{{ period_vecprovince_b.period_vecprovince_year }}</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ (16:30 น.)</div>
              <div class="hrvec-countdown-date">
                {{ period_vecprovince_b.period_vecprovince_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
              </div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="period_vecprovince_b.period_vecprovince_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- เสนอรายชื่อคณะกรรมการ พิจารณาตรวจสอบการย้าย ตำแหน่งครู -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_vecprovinceTeacher.period_vecprovince_enable === '1' || period_vecprovinceTeacher.period_vecprovince_enable === 1">
      <div class="hrvec-priority-bar normal"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #4f46e5">
                <v-icon size="20" color="white">mdi-account-multiple</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="secondary" outlined>
                    <v-icon left x-small>mdi-domain</v-icon>
                    สำนักงานอาชีวศึกษาจังหวัด
                  </v-chip>
                  <v-chip x-small color="indigo">
                    <v-icon left x-small>mdi-account-group</v-icon>
                    คณะกรรมการ
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">เสนอรายชื่อคณะกรรมการ พิจารณาตรวจสอบการย้าย ตำแหน่งครู</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">ครั้งที่ {{ period_vecprovinceTeacher.period_vecprovince_times }}/{{ period_vecprovinceTeacher.period_vecprovince_year }}</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ (16:30 น.)</div>
              <div class="hrvec-countdown-date">
                {{ period_vecprovinceTeacher.period_vecprovince_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
              </div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="period_vecprovinceTeacher.period_vecprovince_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- พิจารณาตรวจสอบการย้าย ตำแหน่งครู -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_vecprovincemanage.period_vecprovince_enable === '1' || period_vecprovincemanage.period_vecprovince_enable === 1">
      <div class="hrvec-priority-bar normal"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #0d9488">
                <v-icon size="20" color="white">mdi-gavel</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="secondary" outlined>
                    <v-icon left x-small>mdi-domain</v-icon>
                    สำนักงานอาชีวศึกษาจังหวัด
                  </v-chip>
                  <v-chip x-small color="teal">
                    <v-icon left x-small>mdi-clipboard-check</v-icon>
                    พิจารณาตรวจสอบ
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">พิจารณาตรวจสอบการย้าย ตำแหน่งครู</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">ครั้งที่ {{ period_vecprovincemanage.period_vecprovince_times }}/{{ period_vecprovincemanage.period_vecprovince_year }}</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ (16:30 น.)</div>
              <div class="hrvec-countdown-date">
                {{ period_vecprovincemanage.period_vecprovince_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
              </div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="period_vecprovincemanage.period_vecprovince_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "HRvecAlertMissionProvince",
  components: { FlipCountdown },

  data() {
    return {
      ApiKey: "HRvec2021",
      period_vecprovinceTeacher: [],
      period_vecprovincemanage: [],
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },
      period_vecprovince_b: [],
      period_vecprovince_ap: [],
      period_vecprovince_apdir: [],
      period_vecprovince_dirb: []
    };
  },

  async mounted() {
    await this.period_vecprovinceTeacherQuery();
    await this.period_vecprovincemanageQuery();
    await this.period_vecprovince_Approve();
    await this.period_vecprovince_Approve_dir();
    await this.period_vecprovince_bAs();
    await this.period_vecprovince_dirbQr();
  },

  filters: {
    moment: function(date, operation, value) {
      if (!date) return '';
      
      if (operation === 'add' && value === '543 years') {
        return {
          moment: function(format) {
            const d = new Date(date);
            d.setFullYear(d.getFullYear() + 543);
            if (format === 'D MMMM YYYY') {
              return d.toLocaleDateString('th-TH', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              });
            }
            return d.toLocaleDateString('th-TH');
          }
        };
      }
      return date;
    }
  },

  methods: {
     formatDateToThaiIntl(dateString) {
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "Asia/Bangkok"
      };
      return new Intl.DateTimeFormat("th-TH", options).format(date);
    },

    async period_vecprovince_Approve() {
      let result_period;
      result_period = await this.$http.post("period_vecprovince.php", {
        ApiKey: this.ApiKey,
        period_vecprovince_enable: "1",
        period_vecprovinc_id: "201"
      });
      this.period_vecprovince_ap = result_period.data;    
    },

    async period_vecprovince_Approve_dir() {
      let result_period;
      result_period = await this.$http.post("period_vecprovince.php", {
        ApiKey: this.ApiKey,
        period_vecprovince_enable: "1",
        period_vecprovinc_id: "401"
      });
      this.period_vecprovince_apdir = result_period.data;   
    },

    async period_vecprovince_dirbQr() {
      let result_period;
      result_period = await this.$http.post("period_vecprovince.php", {
        ApiKey: this.ApiKey,
        period_vecprovince_enable: "1",
        period_vecprovinc_id: "40102"
      });
      this.period_vecprovince_dirb = result_period.data;     
    },

    async period_vecprovince_bAs() {
      let result_period;
      result_period = await this.$http.post("period_vecprovince.php", {
        ApiKey: this.ApiKey,
        period_vecprovince_enable: "1",
        period_vecprovinc_id: "20102"
      });
      this.period_vecprovince_b = result_period.data;    
    },

    async period_vecprovinceTeacherQuery() {
      let result_period;
      result_period = await this.$http.post("period_vecprovince.php", {
        ApiKey: this.ApiKey,
        period_vecprovince_enable: "1",
        period_vecprovinc_id: "301"
      });
      this.period_vecprovinceTeacher = result_period.data;   
    },

    async period_vecprovincemanageQuery() {
      let result_period;
      result_period = await this.$http.post("period_vecprovince.php", {
        ApiKey: this.ApiKey,
        period_vecprovince_enable: "1",
        period_vecprovinc_id: "101"
      });
      this.period_vecprovincemanage = result_period.data;    
    }
  },

  beforeDestroy() {
    // Clear intervals when component is destroyed
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
};
</script>

<style scoped>
/* Thai Font */
* {
  font-family: 'Sarabun', 'Roboto', sans-serif !important;
}

/* Container */
.province-alert-container {
  padding: 1rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%);
  min-height: 100vh;
}

/* Dashboard Header */
.dashboard-header {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 50%, #5b21b6 100%);
  color: white;
  padding: 3rem 2rem;
  border-radius: 25px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(124, 58, 237, 0.2);
}

.dashboard-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="1.5" fill="rgba(255,255,255,0.15)"/><circle cx="80" cy="40" r="2" fill="rgba(255,255,255,0.1)"/><circle cx="40" cy="80" r="1" fill="rgba(255,255,255,0.12)"/><circle cx="60" cy="15" r="1.2" fill="rgba(255,255,255,0.08)"/></svg>');
  pointer-events: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.header-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
}

/* Mission Cards */
.mission-card {
  border-radius: 20px !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg, #ffffff 0%, #fefefe 50%, #fdfdfd 100%);
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.mission-card.card-hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.12) !important;
}

/* Mission Stripes */
.mission-stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  z-index: 1;
}

.mission-stripe.director-evaluation {
  background: linear-gradient(45deg, #f97316, #ea580c);
  box-shadow: 0 0 20px rgba(249, 115, 22, 0.3);
}

.mission-stripe.qualification-check {
  background: linear-gradient(45deg, #06b6d4, #0891b2);
  box-shadow: 0 0 20px rgba(6, 182, 212, 0.3);
}

.mission-stripe.director-qualification {
  background: linear-gradient(45deg, #a855f7, #9333ea);
  box-shadow: 0 0 20px rgba(168, 85, 247, 0.3);
}

.mission-stripe.assistant-evaluation {
  background: linear-gradient(45deg, #10b981, #059669);
  box-shadow: 0 0 20px rgba(16, 185, 129, 0.3);
}

.mission-stripe.teacher-committee {
  background: linear-gradient(45deg, #6366f1, #4f46e5);
  box-shadow: 0 0 20px rgba(99, 102, 241, 0.3);
}

.mission-stripe.teacher-review {
  background: linear-gradient(45deg, #14b8a6, #0d9488);
  box-shadow: 0 0 20px rgba(20, 184, 166, 0.3);
}

/* Mission Content */
.mission-content {
  padding-left: 25px;
}

.mission-badge {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.mission-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
  line-height: 1.4;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.mission-subtitle {
  font-size: 1.2rem;
  font-weight: 600;
  color: #475569;
}

.highlight-text {
  background: linear-gradient(120deg, #dbeafe 0%, #fef3c7 50%, #fee2e2 100%);
  padding: 3px 10px;
  border-radius: 10px;
  font-weight: 700;
  color: #1e293b;
  border: 1px solid rgba(124, 58, 237, 0.2);
}

/* Mission Details */
.mission-details {
  margin-top: 1.2rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.8rem;
  font-size: 1rem;
  line-height: 1.6;
  color: #475569;
}

.detail-item:last-child {
  margin-bottom: 0;
}

/* Countdown Container */
.countdown-container {
  text-align: center;
  padding: 2.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
}

.countdown-header {
  margin-bottom: 1.8rem;
}

.countdown-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  line-height: 1.3;
}

.deadline-date {
  font-size: 1.2rem;
  font-weight: 700;
  color: #7c3aed;
  margin-bottom: 0.6rem;
}

.countdown-label {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

.countdown-timer {
  margin: 2rem 0;
}

.countdown-timer >>> .flip-countdown {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.countdown-timer >>> .flip-countdown__piece {
  background: linear-gradient(145deg, #ffffff, #f8fafc) !important;
  color: #1e293b !important;
  border-radius: 15px !important;
  font-weight: 700 !important;
  font-size: 1.5rem !important;
  min-width: 65px !important;
  height: 65px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8) !important;
  border: 2px solid rgba(226, 232, 240, 0.8) !important;
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.9rem !important;
  color: #64748b !important;
  margin-top: 10px !important;
  font-weight: 600 !important;
}

/* Info Cards */
.info-section {
  margin-top: 3rem;
}

.info-card {
  border-radius: 15px !important;
  background: linear-gradient(145deg, #ffffff, #f8fafc) !important;
  border: 1px solid rgba(226, 232, 240, 0.6);
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
}

.info-card-title {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  color: #1e293b !important;
  font-weight: 600 !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.6);
}

.info-list {
  padding: 0;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #475569;
}

.info-item:last-child {
  margin-bottom: 0;
}

/* Text Utilities */
.text-error {
  color: #ef4444 !important;
  font-weight: 600;
}

.text-primary {
  color: #3b82f6 !important;
  font-weight: 600;
}

.text-info {
  color: #06b6d4 !important;
  font-weight: 600;
}

.text-success {
  color: #10b981 !important;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .header-title {
    font-size: 2.2rem;
  }
  
  .mission-title {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    padding: 2rem 1rem;
    border-radius: 15px;
  }
  
  .header-title {
    font-size: 1.8rem;
  }
  
  .header-subtitle {
    font-size: 1rem;
  }
  
  .mission-title {
    font-size: 1.3rem;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .countdown-container {
    margin-top: 2rem;
    padding: 1.5rem;
  }
  
  .countdown-timer >>> .flip-countdown__piece {
    min-width: 50px !important;
    height: 50px !important;
    font-size: 1.2rem !important;
  }
  
  .countdown-title {
    font-size: 0.9rem;
    text-align: center;
  }
}

@media (max-width: 600px) {
  .province-alert-container {
    padding: 0.5rem;
  }
  
  .mission-card {
    margin-bottom: 1.5rem;
  }
  
  .detail-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .detail-item .v-icon {
    margin-bottom: 4px;
  }
  
  .mission-badge {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .countdown-timer >>> .flip-countdown {
    gap: 8px;
  }
  
  .countdown-timer >>> .flip-countdown__piece {
    min-width: 45px !important;
    height: 45px !important;
    font-size: 1rem !important;
  }
}

/* Animation Effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mission-card {
  animation: fadeInUp 0.6s ease-out;
}

.mission-card:nth-child(2) { animation-delay: 0.1s; }
.mission-card:nth-child(3) { animation-delay: 0.2s; }
.mission-card:nth-child(4) { animation-delay: 0.3s; }
.mission-card:nth-child(5) { animation-delay: 0.4s; }
.mission-card:nth-child(6) { animation-delay: 0.5s; }
.mission-card:nth-child(7) { animation-delay: 0.6s; }

.info-card {
  animation: fadeInUp 0.6s ease-out;
  animation-delay: 0.8s;
  animation-fill-mode: both;
}

/* Vuetify Overrides */
.v-chip.v-chip--outlined {
  border-width: 2px !important;
  font-weight: 600 !important;
}

.v-btn {
  text-transform: none !important;
}

/* Focus States for Accessibility */
.mission-card:focus-within {
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.3);
}

/* Enhanced Mission Cards Effects */
.mission-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.6s;
  pointer-events: none;
}

.mission-card:hover::before {
  transform: translateX(100%);
}

/* Custom Badge Animations */
.mission-badge .v-chip {
  transition: all 0.3s ease;
}

.mission-badge .v-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

/* Micro-interactions */
.detail-item:hover .v-icon {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.mission-title:hover .v-icon {
  transform: rotate(5deg) scale(1.1);
  transition: transform 0.3s ease;
}

/* Info Card Enhancements */
.info-card .v-card__title {
  border-radius: 15px 15px 0 0 !important;
}

.info-item:hover {
  background: rgba(124, 58, 237, 0.05);
  border-radius: 8px;
  padding: 8px;
  margin: 0 -8px 8px -8px;
  transition: all 0.2s ease;
}

/* Enhanced Countdown Styling */
.countdown-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);
  border-radius: 20px;
  pointer-events: none;
}
</style>
